import { render } from "./Anmerkungen.vue?vue&type=template&id=3a4caeb3&scoped=true&ts=true"
import script from "./Anmerkungen.vue?vue&type=script&lang=ts"
export * from "./Anmerkungen.vue?vue&type=script&lang=ts"

import "./Anmerkungen.vue?vue&type=style&index=0&id=3a4caeb3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4caeb3"]])

export default __exports__